import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text" }
const _hoisted_2 = { class: "input-row" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    max_width: "50%",
    min_width: "30em"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, "Set file storage limit for " + _toDisplayString($data.user.name) + " (" + _toDisplayString($data.user.email) + ")", 1 /* TEXT */),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Input, {
          modelValue: $data.limit,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.limit) = $event)),
          class: "input",
          type: "number",
          min: "0"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _cache[1] || (_cache[1] = _createElementVNode("label", { class: "bytes" }, "bytes", -1 /* HOISTED */))
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, { onClick: $options.submit }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" Set limit ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_Button, { onClick: $options.close }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}